let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e1ip1")).then(() => parcelRequire('gKNWn'));